module.exports = __webpack_public_path__ + "static/media/6423.ff397751.jpg";